export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "Label telah berhasil ditambahkan ke Akun Trading Anda.",
        ok: "OK",
        add_account_label: "Tambah Label Akun",
        trading_account: "Akun Trading",
        select_trading_id: "Pilih ID Trading",
        label: "Label",
        alpha_numeric_characters : "Berikan label ke akun Anda: (Alfanumerik hingga 15 karakter)",
        apply: "Terapkan",
        cancel: "Batal",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "Kami telah menerima permintaan Anda untuk mengubah leverage ID trading Anda",
        from :"dari",
        to :"ke",
        confirm_mail_id:"Untuk konfirmasi, silakan klik pada tautan konfirmasi yang dikirimkan ke ID e-mail Anda yang terdaftar.",
        leverage_successfully_change:"Permintaan perubahan leverage berhasil diproses",
        change_account_leverage:"Mengubah Leverage Akun",
        select_trading_account :"Pilih Akun Trading",
        existing_leverage :"Leverage Sebelumnya",
        new_leverage :"Leverage Baru",
        select_new_leverage :"Pilih leverage baru",
        change_leverage:"Mengubah Leverage",
        account_leverage_reduced :"Bila leverage akun diubah dari leverage saat ini, maka akan menaikkan margin yang digunakan pada trading terbuka Anda (bila ada).",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"Diwajibkan untuk menuntaskan KYC sebelum membuat lebih dari satu Akun Live.",
        submit_proof_address:"Harap kirim bukti alamat menggunakan tiket dukungan ",
        click_here:"Klik di sini",
        email_to: "atau email ke",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "Bukti Alamat berikut ini dapat diterima:",
        utility_bill: "Tagihan Utilitas",
        bank_statement: "Rekening Koran",
        government_issued:"Dokumen Pajak yang Diterbitkan Pemerintah",
        note:"Catatan",
        proof_of_address:"Bukti alamat diharuskan tidak lebih lama dari 4 bulan.",
        account :"Akun",
        select_platform:"Pilih Platform",
        select_account_type:"Pilih Tipe Akun",
        connect_your_account:"Apakah Anda ingin menghubungkan akun Anda dengan ZuluTrade?",
        select_leverage:"Pilih Leverage",
        select_account_base_currency:"Pilih mata uang Basis Akun",
        select_currency:"Pilih Mata Uang",
        Password:"Kata Sandi",
        minimum_password_length5:"Panjang minimum kata sandi adalah 5 karakter dan harus mengandung setidaknya 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        minimum_password_length8:"Panjang minimum kata sandi adalah 8 karakter dan harus mengandung setidaknya 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        spcl_characters:"# dari karakter",
        lowercase_letter:"Huruf Kecil",
        capital_letter:"Huruf Kapital",
        number: "Angka",
        special_character:"Karakter khusus",
        confirm_password :"Konfirmasi Kata Sandi",
        trade_With_virtual_funds:"Trading Dengan Dana Virtual",
        test_strategies:"Uji Strategi Gratis",
        risk_free_trading:"Trading Tanpa Risiko",
        live_market_feed: "Market Feed Langsung",
        liquidity_from_top :"Likuiditas Dari LP Top",
        effective_trading:"Sarana Trading Efektif",
        instant_execution:"Eksekusi Instan",
        low_commissions:"Komisi dan Spread Rendah",
        create_new:"Buat Baru",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "Aktifkan Otentikasi 2 Faktor",
        click_to_enable: "Klik untuk Mengaktifkan",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"Kami telah menerima permintaan transfer Anda",
        from_trading_account:"dari akun trading",
        to_confirm:"Untuk konfirmasi, silakan klik pada tautan konfirmasi yang dikirimkan ke ID e-mail Anda yang terdaftar.",
        internal_transfer_request:"Permintaan transfer internal Anda dari akun",
        for_amount:"sejumlah",
        to_account:"ke akun",
        was_succesfull :"telah berhasil dengan jumlah",
        internal_transfer: "Transfer Internal",
        transfer_From: "Transfer Dari",
        transfer_to:"Transfer Ke",
        balance: "Saldo",
        enter_amount: "Masukkan Jumlah",
        USE_MAX:"GUNAKAN MAKS",
        proceed:"Lanjutkan",
        Internal_Transfer_ZIP:"Transfer Internal tidak tersedia untuk akun ZTP.",
        In_case_of_internal_transfer:"Catatan: Dalam hal transfer internal antar akun dengan mata uang basis yang berbeda, jumlah yang ditransfer akan menyesuaikan dengan harga pasar.",
        
        /*=== manage-account.vue ====*/
        attention :"Perhatian - Anda meminta untuk menghapus ID Trading",
        note_after_requesting:"Catatan: - Setelah permintaan, akun Anda akan dihapus dari catatan dan Anda tidak akan bisa mengembalikannya lagi.",
        after_clicking:"Setelah mengklik tombol konfirmasi, Anda akan menerima tautan konfirmasi pada ID email Anda yang terdaftar untuk menghapus akun trading Anda",
        currency: "Mata Uang",
        Account_Type: "Jenis Akun",
        Account_Label: "Label Akun",
        Bonus: "Bonus",
        Leverage: "Leverage",
        Equity: "Ekuitas",
        Create_Demo_Account: "Buat Akun Demo",
        Create_Live_Account :"Buat Akun Live",
        internal_transfer_CAP:"TRANSFER INTERNAL",
        web_trading:"TRADING WEB",
        add_account_label_CAP:"TAMBAH LABEL AKUN",
        change_laverage:"UBAH LEVERAGE",
        delete_account:"Hapus Akun",
        reset_trading_password:"RESET KATA SANDI TRADING",
        
        verifying_your_request: "Memverifikasi permintaan Anda...",
        success: "SUKSES",
        error: "TERJADI KESALAHAN",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"Kami telah menerima permintaan Anda untuk mereset kata sandi Investor. Untuk konfirmasi, silakan klik pada tautan konfirmasi yang dikirimkan ke ID e-mail Anda yang terdaftar.",
        change_investor_password:"Berhasil Mengubah Kata Sandi Investor.",
        reset_investor_password:"Reset Kata Sandi Investor",
        investor_password:"Kata Sandi Investor",
        master_password:"Kata Sandi Master",
        trading_iD: "ID Trading",
        enter_new_password:"Masukkan Kata Sandi Baru",
        confirm_new_password :"Konfirmasi Kata Sandi Baru",
        password_must_contain:"Kata sandi Anda harus berisi min. 6 karakter dan maks. 10 karakter, mengandung sedikitnya 1 angka, 1 karakter huruf kapital, dan 1 karakter Khusus (!@$%*)",
        change_Password:"Ubah Kata Sandi",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"Reset Kata Sandi Master",
        click_reset:"Klik di sini untuk mereset",
        password_caption:"Kata Sandi Investor adalah kata sandi baca saja yang tidak mengizinkan pengguna untuk trading. Bila Anda masuk menggunakan Kata Sandi Master, Anda mendapatkan akses penuh dan hak untuk trading di akun.",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "Perusahaan",
        account_type: "Jenis Akun",
        select_account_type: "Pilih Jenis Akun",
        individual: "Individual",
        name_of_company: "Nama perusahaan",
        country_of_company: "Negara perusahaan",
        select_company_country: "Pilih negara perusahaan",
        registration: "Pendaftaran",
        email_company: "Email perusahaan",
        Password: "Kata sandi",
        min_password_length8: "Panjang kata sandi minimum adalah 8 karakter dan harus mengandung minimal 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        spcl_characters: "# karakter",
        lowercase_letter: "Huruf kecil",
        capital_letter: "Huruf kapital",
        number: "Nomor",
        special_character: "Karakter khusus",
        confirm_password: "Konfirmasi Kata Sandi",
        Phone_Number: "Nomor Telepon",
        have_read: "Saya telah membaca, memahami, dan menerima",
        terms_conditions: "Syarat dan Ketentuan",
        accept_terms_conditions: "Harap setujui syarat dan ketentuan",
        given_your_residency: "Menimbang tempat tinggal Anda, maka Anda akan tergabung dengan Triple A Experts Investment Services (GR) yang diregulasi oleh HCMC. Anda dapat melihat proteksi dan syarat & ketentuan yang tersedia di situs web kami. Dengan mengeklik ",
        continue: "lanjutkan",
        triple_investment_services: "Anda menyetujui pembukaan akun Anda pada Triple A Experts Investment Services (GR).",
        register: "DAFTAR",
        already_have_account: "Sudah memiliki akun?",
        login: "Login",
        /*=== forgot-password.vue ====*/
        confirmation_link: "Tautan konfirmasi telah dikirim ke ID email Anda yang terdaftar. Silakan klik tautan untuk reset kata sandi login Anda.",
        ok: "OK",
        this_email_address: "Alamat email ini tidak terdaftar dengan kami.",
        click_here: "Klik di sini",
        create_account_now: "untuk membuat akun sekarang",
        forgot_password: "Lupa Kata Sandi",
        email_address: "Alamat Email",
        submit: "Kirim",
        dont_have_account: "Belum memiliki akun?",
        create_account_now_CAP: "BUAT AKUN SEKARANG!",
        /*=== login.vue ====*/
        client_login: "Login Nasabah",
        remember_me: "Ingat saya",
        two_step_verification: "Verifikasi dua langkah",
        google_authenticator: "Harap masukkan kode sandi sekali pakai yang ditampilkan di aplikasi Google Authenticator.",
        google_auth_code: "Kode Otentikasi Google",
        /*=== register.vue ====*/
        sent_an_OTP: "Kami telah mengirimkan OTP ke",
        complete_your_registration: "Harap masukkan kode untuk memverifikasi dan menuntaskan pendaftaran Anda.",
        otp: "OTP",
        Register_heading: "Daftar",
        first_name: "Nama depan",
        last_name: "Nama belakang",
        email: "Email",
        country: "Negara",
        select_residence_country: "Pilih negara domisili",
        privacy_policy: "Kebijakan Privasi",
        accept_privacy_policy: "Harap setujui kebijakan privasi",
        experts_investment_services: "Menimbang tempat tinggal Anda, Anda akan tergabung dengan Triple A Experts Investment Services (GR) yang diregulasi oleh HCMC. Anda dapat melihat proteksi dan syarat & ketentuan yang tersedia di situs web kami. Dengan mengeklik ",
        opening_your_account: "Anda menyetujui pembukaan akun Anda pada Triple A Experts Investment Services (GR).",
        /*=== reset-password.vue ====*/
        login_password_change: "Kata sandi login Anda telah berhasil diubah",
        reset_password: "Reset Kata Sandi",
        reset: "Reset",
    },
    //H
    copy_trading: {
        copy_trading: "Salin Trading",
        copy_trading_header: "Raih profit dengan menyalin secara otomatis transaksi trading manajer strategi",
        leading_traders: "SECARA OTOMATIS MENYALIN TRADER TERKEMUKA",
        diversified_trading: "PORTOFOLIO TRADING TERDIVERSIFIKASI",
        monitor_profit: "MONITOR & UNTUNG",
        copy_traders: "BAGAIMANA CARA MENYALIN TRADING?",
        one: "1.",
        one_header: "Buka Akun Live dan lakukan deposit.",
        two: "2.",
        two_header: "Pilih Manajer Strategi.",
        three: "3.",
        three_header: "Setujui syarat dan ketentuan.",
        four: "4.",
        four_header: "Berikan persetujuan Anda.",
        five: "5.",
        five_header: "Raih profit dengan menyalin trading.",
        order_processing: "PEMROSESAN ORDER CEPAT",
        end_result: "KONTROL ATAS HASIL AKHIR",
        trading_skills: "TINGKATKAN KEPIAWAIAN TRADING ANDA",
        start: "Mulai"
    },
    downloads: {
        mt_four_desktop: "MT4 Desktop",
        mt_four_android: "MT4 Android",
        mt_four_ios: "MT4 iOS",
        mt_four_web_trader: "MT4 Web Trader",
        mt_five_desktop: "MT5 Desktop",
        mt_five_android: "MT5 Android",
        mt_five_ios: "MT5 iOS",
        mt_five_web_trader: "MT5 Web Trader",
        act_trader_desktop: "Act Trader Desktop",
        act_trader_android: "Act Trader Android",
        act_trader_ios: "Act Trader iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "Apakah Anda yakin ingin menggunakan Paket",
        package: "VPS?",
        yes: "Ya",
        no: "TIDAK",
        downloads: "Unduhan",
        copy_trading: "Copy Trading",
        vps: "VPS"
    },
    vps: {
        vps_plans: "Paket VPS",
        bronze: "PERUNGGU",
        monthly_subscription_twenty_five: "Langganan Bulanan $25",
        free_deposit_five_thousand: "Dapatkan gratis dengan deposit $5.000 atau lebih",
        compatible_mt_four_five_act: "Kompatibel dengan MT4, MT5, dan Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "Gratis 25 GB Ruang Penyimpanan | 1300 MB RAM | 1 VCPU",
        windows_linux_support: "Mendukung Windows 8/10/12, Linux",
        avail_now: "Gunakan Sekarang",
        silver: "PERAK",
        monthly_subscription_fourty_five: "Langganan Bulanan $45",
        free_on_deposit_ten_thousand: "Dapatkan gratis dengan deposit $10.000 atau lebih",
        free_fifty_gb_disk_space_ram_vcpu: "Gratis 50 GB Ruang Penyimpanan | 2700 MB RAM | 2 VCPU",
        gold: "EMAS",
        monthly_subscription_eighty: "Langganan Bulanan $80",
        free_on_deposit_fifteen_thousand: "Dapatkan gratis dengan deposit $15.000 atau lebih",
        free_seventy_five_gb_disk_space_ram_vcpu: "Gratis Ruang Penyimpanan 75 GB | 5120 MB RAM | 3 VCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "Batalkan Permintaan Penarikan",
        cancel_your_withdrawal_request: "Anda yakin ingin membatalkan Permintaan Penarikan",
        process_request: "Proses Permintaan",
        open_tickets: "Buka Tiket",
        back: "Kembali",
        ticket_number: "Nomor Tiket:",
        created: "Dibuat:",
        reason: "Alasan:"
    },
    bonus: {
        request_to_avail_bonus: "Permintaan Anda untuk menggunakan bonus",
        trading_id: "untuk ID trading",
        click_confirmation_link: "telah diterima. Untuk mengonfirmasi, klik tautan konfirmasi yang dikirimkan ke ID email Anda yang terdaftar.",
        request_to_remove_bonus: "Permintaan Anda untuk menghapus bonus",
        bonus_amount: "Bonus Anda sejumlah",
        successfully_removed_account: "telah berhasil dihapus dari id akun",
        ok: "OK",
        request_to_add_bonus: "Permintaan Anda untuk menambahkan bonus senilai",
        successfully: "telah berhasil.",
        bonus: "BONUS",
        select_trading_id: "Pilih ID Trading",
        use_max: "Gunakan Maks",
        account_type: "Jenis Akun",
        equity: "Ekuitas",
        leverage: "Leverage",
        currency: "Mata Uang",
        current_bonus: "Bonus Saat Ini",
        allowed_bonus: "Bonus yang Diizinkan",
        remove: "Hapus",
        account_first: "Silakan pilih akun terlebih dahulu",
        bonus_amount_base_currency: "Catatan: Masukkan Jumlah Bonus dalam Mata Uang Dasar.",
        point_one: "1. Penawaran Bonus 100% kami tersedia untuk semua nasabah yang menyetor deposit minimum USD 100 dan dengan leverage akun hingga 1:200. Bonus maksimum yang diizinkan adalah USD 40.000 per nasabah.",
        point_two: "2. Profit yang didapat dari trading dengan bonus kami akan menjadi milik Anda. Bonus tidak akan diambil jika Anda menarik profit Anda.",
        point_three: "3. Bonus meningkatkan ketersediaan margin Anda di akun. Namun, kerugian Anda tidak dapat dibebankan ke bonus. Jika total kerugian trading melebihi dana Anda sendiri, sistem akan secara otomatis menghentikan posisi di akun trading Anda tanpa notifikasi terlebih dahulu.",
        point_four: "4. Jumlah bonus proporsional akan diambil dari akun jika Anda menarik dari dana Anda sendiri.",
        read_understood_accepted: "Saya telah membaca, memahami, dan menerima",
        aaafx_bonus_policy: "Kebijakan Bonus AAAFx.",
        accept_aaafx_bonus_policy: "Harap setujui kebijakan bonus AAAFx",
        proceed: "Lanjutkan",
        no_bonus_available_account: "Tidak tersedia bonus untuk akun ini"
    },
    refer_earn: {
        bonus: "BONUS",
        refer_earn: "REFERENSIKAN DAN RAIH PENGHASILAN",
        refer_friend: "Referensikan teman",
        earn_dollar_twenty_five: "Dapatkan $25",
        per_friend: "per teman",
        why_refer_someone_to_us: "Mengapa Anda mereferensikan seseorang kepada kami?",
        refer_someone_point_one: "1. Anda dan teman Anda mendapatkan manfaat bonus referral.",
        refer_someone_point_two: "2. Prosedur yang mudah dan cepat",
        refer_someone_point_three: "3. Anda berdua mendapatkan manfaat dari ketentuan trading kami yang menguntungkan.",
        refer_someone_point_four: "4. Penghasilan tanpa batas dari referral.",
        what_need_to_do: "Inilah yang perlu Anda lakukan:",
        what_need_to_do_point_one: "1. Bagikan tautan referral Anda ke rekanan Anda.",
        what_need_to_do_point_two: "2. Referral Anda mendaftar lewat tautan Anda dan mulai trading.",
        what_need_to_do_point_three: "3. Begitu referral Anda memenuhi syarat, Anda masing-masing memperoleh $25.",
        referral_list: "Daftar Referral Anda"
    },
    referral_list: {
        referrals_list: "Daftar referral",
        list_of_referrals: "Daftar referral untuk melacak penghasilan Anda.",
        s_no: "No.S.",
        name: "Nama",
        email_id: "ID Email",
        account_stage: "Tahap Akun",
        deposits: "Deposit",
        volume_required: "Volume Diperlukan",
        traded_volume: "Volume yang Ditransaksikan",
        qualified: "Memenuhi syarat",
        no_data: "Tidak ada data",
        payment_of_referral_bonus: "Pembayaran Bonus Referral akan dilakukan pada minggu berikutnya setelah Referral dinyatakan memenuhi syarat.",
        referral_bonus_paid_in_aaafx_wallet: "Bonus Referral akan dibayarkan ke wallet AAAFx USD yang lalu dapat ditarik atau ditransfer oleh Pemberi Referensi dan Referral ke akun trading mereka.",
        read_all_terms_conditions: "Baca semua Syarat dan Ketentuan",
        here: "di sini",
        contact_us: "Pertanyaan? Hubungi kami di Live Chat 24/5 atau email kami di",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "Definisi",
        meaning_of_all_above_columns: "Inilah arti dari semua kolom di atas sebagai referensi Anda:",
        name_of_your_referral: "- Nama referral Anda.",
        meaning_of_various_stages: "- Silakan lihat arti dari berbagai tahapan di bawah ini.",
        registered: "1. Terdaftar:",
        registered_link: "Referral Anda telah mendaftar lewat tautan Anda.",
        funded: "2. Didanai:",
        referral_deposited: "Referral Anda telah melakukan deposit.",
        third_point_qualified: "3. Memenuhi syarat:",
        referral_has_deposited: "Referrl Anda telah melakukan deposit dan mencapai volume trading yang diperlukan. Anda berdua telah memenuhi syarat untuk hadiah.",
        deposits_made_by_referral: "- Deposit yang dilakukan oleh referral Anda.",
        volume_requirement: "Persyaratan volume",
        volume_required_for_reward: "- Volume yang diperlukan agar referral Anda memenuhi syarat untuk hadiah.",
        volume_your_referral_traded: "- Volume aktual yang diperdagangkan oleh referral Anda.",
        referral_qualified_for_reward: "- Apakah referral Anda sudah memenuhi persyaratan hadiah atau belum.",
        referral_ib_programs: "Setelah menerima hadiah untuk 10 referral, Anda bisa menjadi seorang IB atau bisa melanjutkan di bawah program Referensi-dan-Raih dengan hadiah masing-masing $20 untuk Anda dan referral. Anda bisa membandingkan keuntungan dan fitur dari program Referral dan IB kami"
    },
    calculators_common: {
        asset_class: "Kelas Aset",
        forex: "Forex",
        commodities: "Komoditas",
        indices: "Indeks",
        account_base_currency: "Mata Uang Dasar Akun",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "Simbol",
        select_symbol: "Pilih Simbol",
        trade_size_in_lots: "Ukuran Trading (dalam lot)",
        calculate: "Hitung"
    },
    margin: {
        margin_required: "Margin yang Diperlukan:",
        maximum_leverage: "Leverage Maksimum:"
    },
    pip: {
        pip_value: "Nilai Pip:"
    },
    swap: {
        server: "Server",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "Jumlah hari",
        long_swap: "Swap Long:",
        short_swap: "Swap Short:"
    },
    //S
    dashboard:{
        select_trading_id: "Pilih ID Trading",
        leverage: "Leverage",
        balance: "Saldo",
        equity: "Ekuitas",
        free_margin: "Margin Bebas",
        pnl: "LR",
        web_trader : "Web Trader",
        fund: "Dana",
        promotions: "Promosi",
        hundred: "100",
        bonus: "Bonus",
        avail: "Gunakan",
        deposit_bonus: "Bonus deposit",
        loading_initial_data: "Memuat data awal",
    },
    enable_2fa:{
        title: "Otentikasi Google (2FA)",
        description: "Untuk Mengaktifkan Otentikasi Dua Faktor (2FA) Google, pindai kode QR dan masukkan kode sandi sekali pakai yang muncul di bawah ini.",
        google_authenticator_code: "Kode Google Authenticator",
        how_to_enable: "Untuk Mengaktifkan Otentikasi 2 Faktor:",
        download: "Unduh",
        google_authenticator_app: "Aplikasi Google Authenticator",
        on_mobile_tablet: "di ponsel/tablet Anda.",
        scan_the : "Pindai",
        qr_code: "Kode QR",
        appearing_above: "yang muncul di atas",
        enter_the: "Masukkan",
        passcode: "Kode Sandi",
        appers_in_google_auth_app: "yang muncul di Aplikasi Google Authenticator Anda",
        click_on_the_button: "Klik tombol",
        click_to_enable: "Klik untuk Mengaktifkan",
    },
    account_security:{
        title: "Otentikasi Google (2FA)",
        description: "Untuk Mengaktifkan Otentikasi Dua Faktor (2FA) Google, pindai kode QR dan masukkan kode sandi sekali pakai yang muncul di bawah ini.",
        google_authenticator_code: "Kode Google Authenticator",
        how_to_enable: "Untuk Mengaktifkan Otentikasi 2 Faktor:",
        download: "Unduh",
        google_authenticator_app: "Aplikasi Google Authenticator",
        on_mobile_tablet: "di ponsel/tablet Anda.",
        scan_the : "Pindai",
        qr_code: "Kode QR",
        appearing_above: "yang muncul di atas",
        enter_the: "Masukkan",
        passcode: "Kode Sandi",
        appers_in_google_auth_app: "yang muncul di Aplikasi Google Authenticator Anda",
        click_on_the_button: "Klik tombol",
        click_to_enable: "Klik untuk Mengaktifkan",
    },
    change_pass:{
        success_message:"Kata sandi Anda telah berhasil diubah.",
        ok:"OKE",
        change_password: "Ubah Kata Sandi",
        existing_password: "Kata Sandi yang Ada",
        new_password: "Kata Sandi Baru",
        confirm_new_password: "Konfirmasi Kata Sandi Baru",
        note_one: "Kata sandi harus berisi minimum 7 dan maksimum 10 karakter, dan harus mengandung setidaknya 1 angka, 1 huruf besar, dan 1 karakter khusus {'(!@#$%^)'}.",
        note_two: "Harap dicatat bahwa kata sandi Profil berbeda dengan kata sandi akun trading Anda",
        cancel: "Batal",
    },
    corporate_varify_step_three:{
        please_upload_file: "mohon unggah berkas",
        out_of_documents: "dari 8 Dokumen",
        add_file: "Tambah berkas",
        max_file_size: "Ukuran maksimum berkas yang bisa diunggah adalah hingga"
    },
    corporate_varify:{
        corporation_info: 'Info Perusahaan',
        account_creation: "Pembuatan Akun",
        verification: "Verifikasi",
        deposit: "Deposit",
        select_platform: "Pilih Platform",
        select_account_type: "Pilih Jenis Akun",
        select_leverage: "Pilih Leverage",
        select_base_currency: "Pilih Mata Uang Dasar Akun",
        select_currency: "Pilih Mata Uang",
        password: "Kata sandi",
        pass_length_alert: "Panjang kata sandi minimum 5 karakter dan harus mengandung setidaknya 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        of_characters: "dari karakter",
        lowercase_letter: 'Huruf kecil',
        capital_letter : "Huruf kapital",
        number: "Nomor",
        special_character : "Karakter khusus",
        confirm_password: "Konfirmasi Kata Sandi",
        create_account : "Buat Akun",
    },
    corporation_info:{
        name_of_company: "Nama perusahaan",
        country_of_company: "Negara perusahaan",
        select_company_country: "Pilih negara perusahaan",
        registration: "Pendaftaran",
        submit: "KIRIM",
    },
    profile:{
        personal_details: "Informasi Pribadi",
        uploaded_documents: "Dokumen yang Diunggah",
        no_documents_yet: "Belum Ada Dokumen",
    },
    questions:{
        financial_details: "Informasi Keuangan",
        sub_heading_one: "Total Estimasi Pendapatan Tahunan",
        select_annual_income: "Pilih Pendapatan Tahunan",
        sub_heading_two: "Total Estimasi Kekayaan Bersih",
        sub_heading_two_desc: "Total aset dikurangi total kewajiban individual atau perusahaan.",
        select_net_worth:"Pilih Kekayaan Bersih",
        sub_heading_three: "Industri dari Pekerjaan",
        select_occupation: "Pilih Pekerjaan",
        sub_heading_four: "Masukkan Pekerjaan Lainnya",
        sub_heading_five: "Sumber Dana",
        sub_heading_six: "Masukkan Sumber Dana Lainnya",
        sub_heading_seven: "Orang yang Dapat Dilaporkan FATCA AS",
        sub_heading_eight: "Negara/Yurisdiksi dari domisili pajak",
        select_residence_country: "Pilih negara domisili",
        sub_heading_nine: "Apakah Anda memiliki nomor TIN?",
        sub_heading_ten: "Masukkan Nomor TIN",
        sub_heading_eleven: "Jika tidak ada TIN, masukkan Alasan",
        select_reasons: "Pilih Alasan",
        enter_reason: "Masukkan Alasan",
        submit: "Kirim",
        dear: "Dengan Hormat",
        message_one: "Dari informasi yang Anda berikan, sepertinya Anda adalah penduduk AS untuk tujuan pajak.",
        message_two: "Harap dicatat, karena Kepatuhan Peraturan kami, AAAFx tidak dapat menerima nasabah penduduk AS untuk tujuan pajak.",
        message_three: "Terima kasih atas pengertian Anda.",
        message_four: "Hormat kami,",
        message_five: "AAAFx",
        close: "Tutup",
    },
    verify:{
        account_creation: "Pembuatan Akun",
        financial_details: "Detail Keuangan",
        verification: "Verifikasi",
        deposit: "Deposit",
        select_platform: "Pilih Platform",
        select_account_type: "Pilih Jenis Akun",
        select_leverage: "Pilih Leverage",
        select_base_currency: "Pilih Mata Uang Dasar Akun",
        select_currency: "Pilih Mata Uang",
        password: "Kata sandi",
        pass_message_one: "Panjang kata sandi minimum 5 karakter dan harus mengandung setidaknya 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        pass_message_two: "Panjang kata sandi minimum adalah 8 karakter dan harus mengandung minimal 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        of_characters: "dari karakter",
        lowercase_letter: "Huruf kecil",
        capital_letter: "Huruf kapital",
        number: "Nomor",
        special_character: "Karakter khusus",
        confirm_password: "Konfirmasi Kata Sandi",
        create_account: "Buat Akun",
        doc_message_one: "Dokumen yang Anda kirimkan telah ditolak oleh proses verifikasi otomatis. Tiket terkait hal yang sama telah dibuat di mana Anda dapat mengunggah ulang dokumen Anda untuk kami verifikasi secara manual jika Anda menginginkannya.",
        view_ticket: "Lihat Tiket",
    },
    verify_quest_bkp:{
        account_creation: "Pembuatan Akun",
        questionnaire: "kuesioner",
        verification: "Verifikasi",
        deposit:"Deposit",
        select_platform: "Pilih Platform",
        select_account_type: "Pilih Jenis Akun",
        select_leverage: "Pilih Leverage",
        select_base_currency: "Pilih Mata Uang Dasar Akun",
        select_currency: "Pilih Mata Uang",
        password: "Kata sandi",
        pass_length_alert: "Panjang kata sandi minimum 5 karakter dan harus mengandung setidaknya 1 huruf kecil, 1 huruf kapital, 1 angka, dan 1 karakter khusus.",
        of_characters: "dari karakter",
        lowercase_letter: "Huruf kecil",
        capital_letter: "Huruf kapital",
        number: "Nomor",
        special_character: "Karakter khusus",
        confirm_password: "Konfirmasi Kata Sandi",
        create_account: "Buat Akun",
        doc_message_one: "Dokumen yang Anda kirimkan telah ditolak oleh proses verifikasi otomatis. Tiket terkait hal yang sama telah dibuat di mana Anda dapat mengunggah ulang dokumen Anda untuk kami verifikasi secara manual jika Anda menginginkannya.",
        view_ticket: "Lihat Tiket",
    },
    close_ticket:{
        heading: "Tiket yang Ditutup",
        create_request: "BUAT PERMINTAAN",
        open_tickets: "BUKA TIKET",
        ticket_number: "Nomor Tiket",
        trading_id: "ID Trading",
        status: "Status",
        subject: "Subjek",
        created: "Dibuat",
        closed: "Ditutup",
        action: "Tindakan",
        view_ticket: "Lihat Tiket",
        no_tickets_found: "Tiket tidak ditemukan",
    },
    open_ticket:{
        heading: "Buka Tiket",
        create_request: "BUAT PERMINTAAN",
        open_tickets: "BUKA TIKET",
        closed_ticket: "Tiket yang Ditutup",
        ticket_number: "Nomor Tiket",
        trading_id: "ID Trading",
        status: "Status",
        subject: "Subjek",
        created: "Dibuat",
        action: "Tindakan",
        view_ticket: "Lihat Tiket",
        no_tickets_found: "Tiket tidak ditemukan",
    },
    request_call:{
        success_message:"Permintaan Anda untuk ditelepon balik telah diterima. Tim kami akan segera menghubungi Anda.",
        ok: "OKE",
        request_call_back:"Minta Telepon Balik",
        first_name: "Nama Depan",
        last_name: "Nama Belakang",
        email_id: "ID Email",
        phone_number: "Nomor Telepon",
        timezone: "Zona Waktu",
        date: "Tanggal",
        preferred_time: "Preferensi Waktu",
        department: "Departemen",
        select_department: "Pilih departemen",
        new_accounts: "Akun Baru",
        deposits: "Deposit",
        withdrawals: "Penarikan",
        partnership: "Kemitraan",
        technical_support: "Dukungan Teknis",
        message: "Pesan",
        send_request: "Kirim Permintaan",
    },
    support_page:{
        success_message:"Tiket Dukungan untuk Anda telah berhasil dibuat. Anda dapat melacaknya dari dalam Buka Tiket.",
        ok:"OKE",
        support: "Dukungan",
        create_req:"BUAT PERMINTAAN",
        open_tickets:"BUKA TIKET",
        closed_tickets: "TIKET DITUTUP",
        otp_msg:"Kami telah mengirim OTP ke alamat terdaftar Anda. Harap membukanya untuk memverifikasi permintaan tiket dukungan.",
        otp: "OTP",
        submit: "Kirim",
        reason: "Alasan",
        select_a_reason: "Pilih alasan",
        trading_id: "ID Trading",
        select_trading_account: "Pilih Akun Trading",
        subject: "Subjek",
        trade_order_id: "ID Order Trading",
        time_of_trade_opening: "Waktu Pembukaan Trading",
        time_of_trade_closing: "Waktu Penutupan Trading",
        instrument_traded: "Instrumen yang Ditransaksikan",
        type_of_trade: "Jenis Trading",
        select_trade_type: "Pilih jenis Trading",
        details_of_the_issue: "Detail masalah",
        refund_claim_amount: "Jumlah Klaim Pengembalian Dana",
        message: "Pesan",
        note: "CATATAN",
        file_attachments: "Lampiran Berkas",
        file_size_msg: "Ukuran dokumen tidak boleh melebihi 1MB",
        file_format_msg: "Format berkas hanya boleh (jpeg atau pdf) saja",
        lowercase_note: "Catatan",
        note_desc: "Jika ada kesalahan saat melakukan operasi akun, lampirkan juga tangkapan layar saat membuat tiket",
        create_support_request: "Buat Permintaan Dukungan",
    },
    become_ib:{
        heading: "Mengenalkan Broker",
        description: "Tingkatkan penghasilan Anda dengan Program IB kami. <br /> Dapatkan tautan khusus Anda, bagikan ke teman-teman Anda dan dapatkan komisi setiap kali mereka melakukan trading.",
        sub_heading: "Kami menawarkan dua kategori program IB:",
        point_one: "Program IB Standar- Langsung dapatkan 20% atas penghasilan komisi kami dari nasabah Anda. Ini berguna untuk IB pemula yang ingin memulai dari awal atau dapat mulai membawa volume nasabah yang terbatas ke kami.",
        point_two: "Program IB Tingkat Lanjut- Ini adalah program IB yang sangat menguntungkan dan disesuaikan untuk para IB kami yang lebih besar. Ini berguna untuk orang yang memiliki basis nasabah besar yang dapat mendatangkan volume lebih besar.",
        note_one: "Anda dapat berpindah dari Program IB Standar ke Program IB Tingkat Lanjut, setelah membuat jaringan Anda cukup besar.",
        earn_with: "Raih pemasukan dengan",
        zero_investment_or: "investasi nol atau",
        experience: "dapatkan",
        weekly_ib: "Pembayaran",
        commissions: "Komisi",
        payouts: "IB mingguan",
        unlimited: "Potensi",
        earnings: "penghasilan",
        potential: "tak terbatas",
        sub_cont_point_four: "Program IB tingkat lanjut yang sangat menguntungkan dan dapat disesuaikan sepenuhnya",
        ultra_fast: "Penarikan",
        withdrawals_of_ib: "komisi IB",
        commission: "ultra cepat",
        easy_user: "Antarmuka pengguna",
        interface_of: "IB Portal",
        ib_portal: "yang mudah",
        dedicated: "Manajer",
        account: "Akun",
        manager: "Khusus",
        helpful_and: "Materi",
        free_marketing: "Pemasaran Berguna",
        material: "dan Gratis",
        become_an_ib: "Menjadi IB",
    },
    pamm_acct:{
        title:"AKUN PAMM",
        description_one: "PAMM (Percentage Allocation Management Module) adalah akun manajerial di mana manajer mengeksekusi trading di semua sub-akunnya. Manajer dan Investor bebas memilih struktur komisi kinerja, dan kami akan mengurusnya agar siap pakai.",
        description_two: "AAAFx menyediakan solusi trading PAMM yang sangat fleksibel dan sudah disesuaikan.",
        sub_title: "Bagaimana cara mendaftar sebagai Manajer PAMM",
        sub_Point_one: "Akun Manajer PAMM Anda dapat dibuka setelah Anda memiliki setidaknya empat investor dengan total deposit $5.000 atau lebih.",
        sub_Point_two: "Silakan mendaftar sebagai IB untuk menjadi Manajer PAMM dengan kami. Ajak nasabah Anda mendaftar lewat tautan IB Anda, penuhi ketentuan pertama di atas.",
        sub_Point_three: "Hubungi kami lewat Live Chat atau email kami di",
        sub_Point_four: "Mulai dapatkan komisi IB selain dari Komisi Kinerja PAMM.",
        minimul_investment: "INVESTASI MINIMAL",
        ease_of_access: "KEMUDAHAN AKSES",
        ultimate_trading_conditions: "KETENTUAN TRADING TERBAIK",
        trade_security: "KEAMANAN TRADING",
        request_pamm: "Minta PAMM",
    },
    add_payment_methods:{
        success_message: "Metode pembayaran Anda telah berhasil ditambahkan. Anda dapat melacaknya lewat Buka Tiket.",
        ok: "OK",
        otp_message: "Kami telah mengirimkan OTP ke email Anda yang terdaftar. Harap masukkan untuk memverifikasi permintaan tiket dukungan.",
        otp: "OTP",
        submit: "Kirim",
        page_heading: "Tambah Metode Pembayaran",
        select_payment_method: "Pilih Metode Pembayaran",
        select_method: "Pilih Metode",
        bank: "Bank",
        credit_card: "Kartu Kredit",
        crypto: "Kripto",
        select_crypto_currency: "Pilih Mata Uang Kripto",
        select_crypto: "Pilih Kripto",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "Tambah Detail Bank Anda",
        bank_name: "Nama Bank",
        account_name: "Nama Akun",
        account_number: "Nomor Akun",
        country: "Negara",
        select_country: "Pilih negara",
        iban: "IBAN",
        iban_note: "Bank Saya Tidak Menerbitkan IBAN",
        swift: "SWIFT",
        bic: "BIC",
        sort_code: "Kode Sortir",
        bank_address: "Alamat Bank",
        upload_your_bank_statement: "Unggah Rekening Koran Bank Anda",
        upload_doc_info_one: "Ukuran dokumen tidak boleh melebihi 1MB",
        upload_doc_info_two: "Format berkas hanya boleh (jpeg atau pdf) saja",
        note: "Catatan",
        note_msg: "Jika ada kesalahan saat melakukan operasi akun, lampirkan juga tangkapan layar saat membuat tiket",
        create_support_request: 'Buat Permintaan Dukungan',
        add_your_card_details: "Tambah Detail Kartu Anda",
        creadit_card_number: "Nomor Kartu Kredit",
        month: "Bulan",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "Tahun",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "Kami memerlukan yang berikut ini untuk verifikasi kartu",
        varification_msg_one: "Salinan berwarna sisi depan kartu, menampilkan: nama lengkap, tanggal kedaluwarsa, Nama/logo bank, 4 digit pertama dan 4 digit terakhir nomor kartu kredit dengan 8 digit di tengah disembunyikan.",
        upload_supporting_document: "Unggah Dokumen Pendukung",
        varification_msg_two: "Salinan berwarna sisi belakang kartu dengan kode keamanan CVV disembunyikan. Salinan belakang harus menunjukkan tanda tangan pemegang",
        add_selected_crypto_address: "Tambah Alamat Kripto Pilihan",
        address: "Alamat",
    },
    deposit:{
        account_type: "Jenis Akun",
        select_type: "Pilih jenis",
        live: "Live",
        trading_account: "Akun Trading",
        select_trading_account: "Pilih Akun Trading",
        balance: "Saldo",
        fund: "DANA",
        amount: "Jumlah",
        region: "Wilayah",
        currencies: "Mata Uang",
        processing_time: "Waktu Pemrosesan",
        action: "Tindakan",
        view_more: "Lihat Lebih Banyak",
        currency: "Mata Uang",
        zar: "ZAR",
        swift_code: "Kode Swift",
        beneficiarys_name: "Nama Penerima",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "Nomor Akun",
        user_account_number: "62928423269",
        bank_address: "Alamat Bank",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "Nama Bank",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "Kota",
        city_info: "London",
        country: "Negara",
        country_info: "Britania Raya",
        dixipay_note: "Dixipay hanya menerima deposit dalam EURO",
        you_can_deposit: "Anda dapat melakukan deposit",
        you_can_deposit_msg: "ke alamat berikut dan jumlah yang setara dalam mata uang akun yang dipilih akan ditambahkan setelah konversi",
        copy: "Salin",
        done: "Selesai",
        network_msg: "Jaringan ERC-20 (USDT, USDC, ETH) didukungg, penggunaan jaringan lain tidak akan sampai ke kami.",
    },
    fund_index: {
        add_funds: "Tambah Dana",
        cancel: "Batal",
        ok: "OK",
        your_request_to_add: "Permintaan Anda untuk menambahkan",
        to_your_demo_account_number: "ke Nomor Akun Demo Anda",
        has_been_successfully_completed: "telah berhasil diselesaikan",
        your_request_to_withdraw: "Permintaan Anda untuk menarik",
        from_the_trading_id: "dari ID trading",
        has_been_received: "telah diterima",
        click_to_proceed_withdrawal: "Silakan klik tautan konfirmasi yang dikirim ke ID email Anda yang terdaftar untuk memproses penarikan",
        has_been_successfully: "telah Berhasil",
        your_request_to_add_usd: "Permintaan Anda untuk menambahkan USD",
    },
    request_verify: {
        verifying_your_request: "Memverifikasi permintaan Anda",
        success: "SUKSES",
        go_to_transactions: "Masuk ke Transaksi",
        error: "TERJADI KESALAHAN",
    },
    transactions: {
        list_of_transactions: "Daftar Transaksi",
        deposits: "Deposit",
        withdrawals: "Penarikan",
        bonus: "Bonus",
        deposit_transactions: "Transaksi Deposit",
        filter_by: "Filter menurut",
        select_trading_id: "Pilih ID Trading",
        all: "SEMUA",
        date: "Tanggal",
        account_id: 'Account ID',
        currency: "Mata Uang",
        payment_mode: "Mode Pembayaran",
        deposit_amount: "Jumlah Deposit",
        status: 'Status',
        no_deposits_yet: "Belum ada deposit",
        withdrawal_mode: "Mode Penarikan",
        withdrawal_amount: "Jumlah Penarikan",
        action: "Tindakan",
        view_more : "Lihat Lebih Banyak",
        no_withdrawals_yet: "Belum ada penarikan",
        bonus_amount: "Jumlah Bonus",
        pending : "Tertunda",
        no_bonus_transactions_yet: "Belum ada bonus transaksi",
        deposit_currency: "Mata Uang Deposit",
        account_currency: 'Mata Uang Akun',
        address: 'Alamat',
    },
    withdrawal: {
        kyc_req_msg: "KYC wajib dituntaskan sebelum meminta penarikan. Harap kirimkan bukti alamat menggunakan tiket dukungan",
        Click_here: "Klik di sini",
        or_email_to: 'atau email ke',
        with_step_heading: "Bukti Alamat berikut dapat diterima",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "Tagihan Utilitas",
        with_step_two: "Rekening Koran",
        with_step_three: "Dokumen Pajak Terbitan Pemerintah",
        note: "Catatan",
        note_info: "Bukti alamat harus tidak lebih lama dari 4 bulan",
        ok: "OKE",
        enable_2fa_msg: "2FA wajib diaktifkan untuk mengajukan permintaan penarikan. Harap klik tombol berikut",
        click_to_enable: "Klik untuk Mengaktifkan",
        select_trading_id: "Pilih ID Trading",
        account_id: "ID Akun",
        account_type: "Jenis Akun",
        platform: 'Platform',
        leverage: "Leverage",
        currency: "Mata Uang",
        free_margin: "Margin Bebas",
        note_info_two: "Masukkan jumlah Penarikan dalam Mata Uang Dasar dari Akun Trading Anda.",
        amount: "Jumlah",
        mode_of_payment: "Mode Pembayaran",
        create_transaction: "Buat Transaksi",
        cancel: "Batal",
        add_payment_method: "Tambah Metode Pembayaran",
        no_amount_available: "Tidak Ada Jumlah tersedia di akun ini",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "Pilih akun",
    },
    footer: {
        legal_information: "Informasi Hukum",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. disahkan dan diregulasi oleh Financial Sector Conduct Authority Afrika Selatan (No. FSCA 2017/315029/07).",
        risk_warning: "Peringatan Risiko",
        risk_warning_info: "Trading mata uang spot melibatkan risiko besar dan selalu ada potensi kerugian. Hasil trading Anda mungkin berbeda. Karena faktor risiko trading pasar valuta asing tinggi, hanya dana yang benar-benar untuk “risiko” yang sebaiknya digunakan untuk trading. Jika Anda tidak memiliki modal ekstra yang sepenuhnya dapat dirisikokan untuk hilang, sebaiknya Anda tidak melakukan trading pasar valuta asing. Sistem trading yang “aman” tidak pernah ada, dan tak seorang pun dapat menjamin keuntungan atau bebas dari kerugian.",
    },
    header: {
        welcome: "Selamat datang", 
        profile: 'Profil',
        request_callback: "Minta Ditelepon Balik",
        support_ticket: "Tiket Dukungan",
        change_password: "Ubah Kata Sandi",
        logout: "Keluar",
    },
    pagination: {
        total_records: "Total Data", 
    },
    side_bar: {
        dashboard: "Dasbor",
        manage_accounts: "Kelola Akun",
        fund: "Dana",
        bonus: "Bonus",
        become_a_partner: "Menjadi Mitra",
        tools: "Alat",
        bonus_and_promotions: 'Bonus & Promosi',
    },
    success_box: {
        otp_varify: "Harap masukkan 6 digit Pin Sekali Pakai yang ditampilkan di aplikasi Google Authenticator.",
        cancel: "Batal",
        submit: 'Submit',
        trouble_with_2fa: "Mengalami Kendala dengan Kode Otentikasi Dua Faktor Anda?",
        click_varify_with_email: "Klik Di Sini Untuk Memverifikasi Dengan Email",
        or: "ATAU",
        click_here: "Klik di sini",
        to_enable_2fa: "untuk mengaktifkan 2FA Anda dan menyelesaikan permintaan Anda",
        take_me_back: "Bawa aku kembali",
    },
    tost_message: {
        varify_acc: "Harap verifikasi akun Anda untuk membuat akun live",
        click_to_begin: "Klik untuk memulai proses verifikasi",
    },
    proof_residence_alert: {
        you_have: "Anda memiliki",
        days_left_for_proof: "hari tersisa untuk menyerahkan bukti domisili.",
        click_here: "Klik di sini",
        to_upload: "untuk mengunggah",
    },
    closed_trades: {
        login: "Login",
        order: "Order",
        symbol: "Simbol",
        volume: "Volume",
        open_price: "Harga Buka",
        open_time: "Jam Buka",
        commission: "Komisi",
        type: 'Tipe',
        sl: "SL",
        tp: "TP",
        close_price: 'Harga Penutupan',
        close_time: 'Waktu Penutupan',
        swap: 'Swap',
        pnl: "LR",
        comment: 'Komentar',
        no_record_found: "Data tidak ditemukan",
    },
    open_trade: {
        order: 'Order',
        symbol: 'Simbol',
        type: 'Tipe',
        volume: "Volume",
        open_price: "Harga Buka",
        pnl: "LR",
        no_record_found: "Data tidak ditemukan",
    },
}